import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";

export default function OperationResult(props) {
  const [open, setOpen] = useState(true);
  const [isSuccessful, setIsSuccessful] = useState(props.success);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setOpen(false);
      }, 3000);
    }
  }, []);

  return (
    <Box>
      {open && (
        <Slide direction="down" in={alert}>
          {isSuccessful ? (
            <Alert severity="success">
              <AlertTitle>Success</AlertTitle>
              Operation was completed!
            </Alert>
          ) : (
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              Operation Failed!
            </Alert>
          )}
        </Slide>
      )}
    </Box>
  );
}
